<template>
    <form id="EducationForm" class="needs-validation" novalidate>
        <div class="row g-3">
            <!-- Major Field -->
            <div class="col-md-4">
                <label for="educationDiscipline"><strong>{{ $Translate('educationDiscipline') }}:
                    </strong><span class="text-danger">*</span></label>
                <input type="text" id="educationDiscipline" class="form-control"
                    :placeholder="$Translate('educationDisciplinePlaceholder')"
                    :class="{ 'is-valid': eduSubmitted && educationDisciplineIsValid, 'is-invalid': eduSubmitted && !educationDisciplineIsValid }"
                    v-model="education.educationDiscipline" name="educationDiscipline" required />
            </div>

            <!-- Institute Field -->
            <div class="col-md-4">
                <label for="educationInstitute"><strong>{{ $Translate('educationInstitute') }}:
                    </strong><span class="text-danger">*</span></label>
                <input type="text" id="educationInstitute" class="form-control"
                    :placeholder="$Translate('educationInstitutePlaceholder')"
                    :class="{ 'is-valid': eduSubmitted && educationInstituteIsValid, 'is-invalid': eduSubmitted && !educationInstituteIsValid }"
                    v-model="education.educationInstitute" name="educationInstitute" required />
            </div>

            <!-- Education Level Field -->
            <div class="col-md-4">
                <label for="educationLevel"><strong>{{ $Translate('educationLevel') }}: </strong><span
                        class="text-danger">*</span></label>
                <select class="form-control"
                    :class="{ 'is-valid': eduSubmitted && educationLevelIsValid, 'is-invalid': eduSubmitted && !educationLevelIsValid }"
                    id="educationLevel" v-model="education.educationLevel" required>
                    <option value="" selected disabled>{{ $Translate('selectEducationLevel') }}</option>
                    <option v-for="edu in educationalLevelsList" :key="edu.recId" :value="edu.recId">
                        {{ edu.description }}
                    </option>
                </select>
            </div>

            <!-- Grade  Field -->
            <div class="col-md-4">
                <label for="gradePoint"><strong>{{ $Translate('gradePoint') }}: </strong></label>
                <input type="text" id="gradePoint" class="form-control"
                    :placeholder="$Translate('gradePointPlaceholder')"
                    :class="{ 'is-valid': eduSubmitted && gradePointIsValid, 'is-invalid': eduSubmitted && !gradePointIsValid }"
                    v-model="education.gradePoint" name="gradePoint" />
            </div>

            <!-- From Date Field -->
            <div class="col-md-4">
                <label for="startDate"><strong>{{ $Translate('startDate') }}: </strong></label>
                <input type="date" id="startDate" class="form-control"
                    :class="{ 'is-valid': eduSubmitted && startDateIsValid, 'is-invalid': eduSubmitted && !startDateIsValid }"
                    v-model="education.startDate" name="startDate" />
            </div>

            <!-- To Date Field -->
            <div class="col-md-4">
                <label for="endDate"><strong>{{ $Translate('endDate') }}: </strong><span
                        class="text-danger">*</span></label>
                <input type="date" id="endDate" class="form-control"
                    :class="{ 'is-valid': eduSubmitted && endDateIsValid, 'is-invalid': eduSubmitted && !endDateIsValid }"
                    v-model="education.endDate" name="endDate" required />
            </div>

            <!-- Description Field -->
            <div class="col-md-4">
                <label for="description"><strong>{{ $Translate('description') }}: </strong></label>
                <textarea id="description" class="form-control"
                    :class="{ 'is-valid': eduSubmitted && descriptionIsValid, 'is-invalid': eduSubmitted && !descriptionIsValid }"
                    v-model="education.description" name="description" />
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: 'Education',
    props: {
        education: Object,
        eduSubmitted: Boolean,
        educationList: Array,
        educationalLevelsList: Array,
        educationDisciplineIsValid: Boolean,
        educationInstituteIsValid: Boolean,
        educationLevelIsValid: Boolean,
        gradePointIsValid: Boolean,
        startDateIsValid: Boolean,
        endDateIsValid: Boolean,
        descriptionIsValid: Boolean
    }
}
</script>

<style scoped>
.col-md-4 {
    text-align: start;
}

.col-md-4 label {
    margin-bottom: 10px;
}

.col-md-4 input,
.col-md-4 select,
.col-md-4 textarea {
    margin-bottom: 12px;
}

.col-md-4 select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url('../../../../dist/assets/select.svg') no-repeat right 0.75rem center;
    background-color: #fff;
    background-size: 16px 16px;
    padding-right: 2rem;
    line-height: 1.5;
    height: calc(1.5em + 0.75rem + 2px);
}
</style>